import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/home/index.vue"),
  },
  {
    path: "/openMini",
    name: "OpenMini",
    component: () =>
      import(/* webpackChunkName: "openMini" */ "@/views/openMini/index.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }
  // 防止切换页面后，上一页的滚动间距影响到当前页面
  window.scrollTo(0, 0);
  next();
});

export default router;
